import React, { useState } from "react";

function MarketingDashboard() {
    // Konfiguracija
    const plan = {
        label: "Marketing Plan",
        url: "https://docs.google.com/spreadsheets/d/1hqzC8WhocNBtJlNi_kZmrlc-QJvm4c5O30GWfJKKEaM/edit?usp=sharing",
    };

    const reports = [
        {
            name: "stoja-trade.si",
            url: "https://lookerstudio.google.com/embed/reporting/793d2805-93da-496a-81cf-725214dfbb51/page/kIV1C",
        },
        {
            name: "Diplomatic Real Estate",
            url: "https://lookerstudio.google.com/embed/reporting/e71572cd-0523-45b9-a4fe-acdee9cef483/page/kIV1C",
        },
        {
            name: "Oddaja- Najem",
            url: "https://lookerstudio.google.com/embed/reporting/b8fb661d-41cd-473a-b92a-bd04b4036613/page/kIV1C",
        },
        {
            name: "Rent-A-Real-Estate",
            url: "https://lookerstudio.google.com/embed/reporting/103d896a-4cbe-4ead-a1b1-75ee914b8dca/page/kIV1C",
        },
        {
            name: "DCS",
            url: "https://lookerstudio.google.com/embed/reporting/5c6e59d7-bf73-4bdd-be25-c30cf1f015b6/page/kIV1C",
        },
        {
            name: "RETV",
            url: "https://lookerstudio.google.com/embed/reporting/73c0d923-f4cf-4298-9dbc-a50f8a324aa7/page/kIV1C",
        },
    ];

    const [view, setView] = useState("plan"); // "plan" ali "reports"
    const [selectedReportIndex, setSelectedReportIndex] = useState(0);
    const [isFullScreen, setIsFullScreen] = useState(false);

    // Pridobimo trenutni URL glede na izbran pogled
    const currentUrl =
        view === "plan" ? plan.url : reports[selectedReportIndex].url;

    const toggleFullScreen = () => {
        setIsFullScreen(!isFullScreen);
    };

    const renderViewToggleButtons = () => (
        <div className="flex flex-col mb-4 space-y-2 sm:flex-row sm:space-x-4 sm:space-y-0">
            <button
                type="button"
                aria-pressed={view === "plan"}
                className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors w-full sm:w-auto ${
                    view === "plan"
                        ? "bg-blue-600 text-white shadow-md"
                        : "bg-white border border-gray-200 hover:bg-gray-100 text-gray-800"
                }`}
                onClick={() => setView("plan")}
            >
                {plan.label}
            </button>

            <button
                type="button"
                aria-pressed={view === "reports"}
                className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors w-full sm:w-auto ${
                    view === "reports"
                        ? "bg-blue-600 text-white shadow-md"
                        : "bg-white border border-gray-200 hover:bg-gray-100 text-gray-800"
                }`}
                onClick={() => setView("reports")}
            >
                Poročila spletnih strani
            </button>
        </div>
    );

    const renderReportSelectionButtons = () => {
        if (view !== "reports") return null;
        return (
            <div className="flex flex-col flex-wrap gap-2 mb-4 sm:flex-row sm:gap-4">
                {reports.map((report, index) => (
                    <button
                        key={index}
                        type="button"
                        aria-pressed={selectedReportIndex === index}
                        className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors w-full sm:w-auto text-sm sm:text-base ${
                            selectedReportIndex === index
                                ? "bg-blue-500 text-white shadow-md"
                                : "bg-white border border-gray-200 hover:bg-gray-100 text-gray-800"
                        }`}
                        onClick={() => setSelectedReportIndex(index)}
                    >
                        {report.name}
                    </button>
                ))}
            </div>
        );
    };

    const renderFullScreenOverlay = () => {
        if (!isFullScreen) return null;
        return (
            <div
                className="fixed inset-0 z-50 bg-black"
                style={{ overflow: "hidden" }}
            >
                <div className="absolute z-10 top-2 right-2">
                    <button
                        className="px-3 py-2 text-sm font-medium text-white bg-red-600 rounded-lg shadow-md hover:bg-red-700 sm:text-base"
                        onClick={toggleFullScreen}
                    >
                        <span className="hidden sm:inline">
                            Izhod iz celozaslonskega načina
                        </span>
                        <span className="sm:hidden">Zapri</span>
                    </button>
                </div>
                <iframe
                    src={currentUrl}
                    className="w-full h-full"
                    frameBorder="0"
                    style={{ background: "white", border: "none" }}
                    title={
                        view === "plan"
                            ? plan.label
                            : reports[selectedReportIndex].name
                    }
                    allowFullScreen
                    loading="eager"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
                />
            </div>
        );
    };

    return (
        <div className="flex flex-col w-full min-h-screen bg-gray-50">
            <h1 className="p-3 mb-2 text-xl font-bold text-gray-800 sm:text-2xl sm:mb-4 sm:p-4">
                Stojin Marketing Kotiček
            </h1>
            {renderViewToggleButtons()}
            {renderReportSelectionButtons()}

            {/* Main content area */}
            <div className="flex-1 px-2 pb-2 sm:px-3 sm:pb-3">
                <div className="w-full h-[calc(100vh-160px)] rounded-lg overflow-hidden shadow-lg bg-white relative">
                    {/* Fullscreen button */}
                    <div className="absolute z-10 top-2 right-2">
                        <button
                            className="px-2 py-1 text-sm text-white bg-blue-600 rounded shadow-md sm:px-3 hover:bg-blue-700 sm:text-base"
                            onClick={toggleFullScreen}
                        >
                            <span className="hidden sm:inline">
                                {isFullScreen
                                    ? "Izhod iz celozaslonskega načina"
                                    : "Celozaslonski prikaz"}
                            </span>
                            <span className="sm:hidden">
                                {isFullScreen ? "Zapri" : "Razširi"}
                            </span>
                        </button>
                    </div>

                    {/* Google Sheets or Reports iframe */}
                    <iframe
                        src={currentUrl}
                        className="w-full h-full"
                        frameBorder="0"
                        style={{
                            background: "white",
                            border: "none",
                        }}
                        title={
                            view === "plan"
                                ? plan.label
                                : reports[selectedReportIndex].name
                        }
                        allowFullScreen
                        loading="eager"
                        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
                    />
                </div>
            </div>

            {/* Fullscreen overlay */}
            {isFullScreen && (
                <div
                    className="fixed inset-0 z-50 bg-black"
                    style={{ overflow: "hidden" }}
                >
                    <div className="absolute z-10 top-2 right-2">
                        <button
                            className="px-3 py-2 text-sm font-medium text-white bg-red-600 rounded-lg shadow-md hover:bg-red-700 sm:text-base"
                            onClick={toggleFullScreen}
                        >
                            <span className="hidden sm:inline">
                                Izhod iz celozaslonskega načina
                            </span>
                            <span className="sm:hidden">Zapri</span>
                        </button>
                    </div>
                    <iframe
                        src={currentUrl}
                        className="w-full h-full"
                        frameBorder="0"
                        style={{ background: "white", border: "none" }}
                        title={
                            view === "plan"
                                ? plan.label
                                : reports[selectedReportIndex].name
                        }
                        allowFullScreen
                        loading="eager"
                        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
                    />
                </div>
            )}
        </div>
    );
}

export default MarketingDashboard;
